import { render } from "./articlesPagination.vue?vue&type=template&id=2594365c&scoped=true"
import script from "./articlesPagination.vue?vue&type=script&lang=js"
export * from "./articlesPagination.vue?vue&type=script&lang=js"

import "./articlesPagination.vue?vue&type=style&index=0&id=2594365c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2594365c"]])

export default __exports__